// extracted by mini-css-extract-plugin
module.exports = {"root":"_3doHW","itemMeta":"_3X-YD","ratingAndSalesGrid":"_24GHy","priceWrapper":"_2gsmP","gridPrice":"tZyd2","cartButton":"_1vl5N"};